import type { SVGProps } from 'react';

const Theme = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.35355 1C1.25979 1 1.16986 1.03725 1.10355 1.10355C1.03725 1.16986 1 1.25979 1 1.35355V10.4411C1.00712 10.4375 1.01426 10.4339 1.02142 10.4303C1.63745 10.1223 2.36255 10.1223 2.97858 10.4303C2.98574 10.4339 2.99288 10.4375 3 10.4411V1.35355C3 1.25979 2.96275 1.16986 2.89645 1.10355C2.83014 1.03725 2.74021 1 2.64645 1H1.35355ZM3 11.7071L2.84016 11.5473C2.74986 11.457 2.64559 11.3818 2.53136 11.3247C2.19686 11.1574 1.80314 11.1574 1.46864 11.3247C1.35441 11.3818 1.25014 11.457 1.15984 11.5473L1 11.7071V12.7929C1 13.113 1.12718 13.4201 1.35355 13.6464C1.57993 13.8728 1.88696 14 2.20711 14H13.7929C14.113 14 14.4201 13.8728 14.6464 13.6464C14.8728 13.4201 15 13.113 15 12.7929V5.20711C15 4.88696 14.8728 4.57993 14.6464 4.35355C14.4201 4.12718 14.113 4 13.7929 4H4V12.5C4 12.7761 3.77614 13 3.5 13C3.22386 13 3 12.7761 3 12.5V11.7071ZM4 3V1.35355C4 0.994569 3.85739 0.650287 3.60355 0.396447C3.34971 0.142606 3.00543 0 2.64645 0H1.35355C0.994569 0 0.650287 0.142606 0.396447 0.396447C0.142606 0.650287 0 0.994569 0 1.35355V12.7929C0 13.3783 0.232534 13.9396 0.646447 14.3536C1.06036 14.7675 1.62175 15 2.20711 15H13.7929C14.3783 15 14.9396 14.7675 15.3536 14.3536C15.7675 13.9396 16 13.3783 16 12.7929V5.20711C16 4.62175 15.7675 4.06036 15.3536 3.64645C14.9396 3.23253 14.3783 3 13.7929 3H4Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1464 5.14645C11.3417 4.95118 11.6583 4.95118 11.8536 5.14645L12.5 5.79289L13.1464 5.14645C13.3417 4.95118 13.6583 4.95118 13.8536 5.14645C14.0488 5.34171 14.0488 5.65829 13.8536 5.85355L13.2071 6.5L13.8536 7.14645C14.0488 7.34171 14.0488 7.65829 13.8536 7.85355C13.6583 8.04882 13.3417 8.04882 13.1464 7.85355L12.5 7.20711L11.8536 7.85355C11.6583 8.04882 11.3417 8.04882 11.1464 7.85355C10.9512 7.65829 10.9512 7.34171 11.1464 7.14645L11.7929 6.5L11.1464 5.85355C10.9512 5.65829 10.9512 5.34171 11.1464 5.14645Z"
                fill="currentColor"
            />
            <path
                d="M13 9.5C13 9.77614 12.7761 10 12.5 10C12.2239 10 12 9.77614 12 9.5C12 9.22386 12.2239 9 12.5 9C12.7761 9 13 9.22386 13 9.5Z"
                fill="currentColor"
            />
            <path
                d="M10.5111 10.5C10.5111 10.7761 10.2872 11 10.0111 11C9.73495 11 9.5111 10.7761 9.5111 10.5C9.5111 10.2239 9.73495 10 10.0111 10C10.2872 10 10.5111 10.2239 10.5111 10.5Z"
                fill="currentColor"
            />
            <path
                d="M9.54346 9.5C9.54346 9.77614 9.3196 10 9.04346 10C8.76731 10 8.54346 9.77614 8.54346 9.5C8.54346 9.22386 8.76731 9 9.04346 9C9.3196 9 9.54346 9.22386 9.54346 9.5Z"
                fill="currentColor"
            />
            <path
                d="M8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5C7 8.22386 7.22386 8 7.5 8C7.77614 8 8 8.22386 8 8.5Z"
                fill="currentColor"
            />
            <path
                d="M6.5 9C6.5 9.27614 6.27614 9.5 6 9.5C5.72386 9.5 5.5 9.27614 5.5 9C5.5 8.72386 5.72386 8.5 6 8.5C6.27614 8.5 6.5 8.72386 6.5 9Z"
                fill="currentColor"
            />
            <path
                d="M6 10.5C6 10.7761 5.77614 11 5.5 11C5.22386 11 5 10.7761 5 10.5C5 10.2239 5.22386 10 5.5 10C5.77614 10 6 10.2239 6 10.5Z"
                fill="currentColor"
            />
            <path
                d="M6.5 12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.7239 6.5 12Z"
                fill="currentColor"
            />
            <path
                d="M12 10.5C12 10.7761 11.7761 11 11.5 11C11.2239 11 11 10.7761 11 10.5C11 10.2239 11.2239 10 11.5 10C11.7761 10 12 10.2239 12 10.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Theme;
